export const getInstagramDmLink = (username: string) => {
  return `https://ig.me/m/${username}`;
};
